staggeredSlider = document.querySelectorAll('.staggered-section');

staggeredSlider.forEach(section => {

    images = section.querySelector('.staggered-slider-image')
    content = section.querySelector('.staggered-slider')

    jQuery(content).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 10000,
        rows: 0,
        fade: true,
        asNavFor: images,
    });

    jQuery(images).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        rows: 0,
        fade: true,
        asNavFor: content,
    });

    jQuery('.images').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
        ]
    });

    jQuery('.play-video').on('click', function () {
        var video = jQuery(this).siblings('video');
        jQuery(video).get(0).play();

        jQuery(video).attr('controls', true);

        jQuery(this).fadeOut();
    });

})
